const { DEV, VITE_LOCAL } = import.meta.env

import { commentService as local } from './comment.service.local'
import { commentService as remote } from './comment.service.remote'

function getEmptyComment() {
  return {
    postId: '', // מזהה הפוסט שאליו שייכת התגובה
    parentCommentId: null, // מזהה של תגובה הורה (null אם זו תגובה ראשית)
    userId: '', // מזהה המשתמש שהגיב
    content: '', // תוכן התגובה
    createdAt: new Date().toISOString(), // תאריך יצירת התגובה
    likes: [], // רשימת מזהי משתמשים שאהבו את התגובה
    replyCount: 0, // מספר תתי-תגובות
  }
}

const service = VITE_LOCAL === 'true' ? local : remote

export const commentService = { ...service, getEmptyComment }

if (DEV) window.commentService = commentService
